/* eslint-disable react/prop-types */
import { Stack, Typography, Box } from '@mui/material';
import Icon from '../icon/Icon';

const SectionHeader = ({ icon, heading }) => {
  return (
    <Stack alignItems="center" spacing={1} direction="row">
      <Box
        component="img"
        alt="icon"
        height={{ xs: '25px', sm: '25px' }}
        width={{ xs: '25px', sm: '25px' }}
        sx={{
        //   filter:
        // 'invert(50%) sepia(70%) saturate(300%) hue-rotate(210deg) brightness(95%) contrast(90%)',
    }}
        src={icon}
      />
      <Typography color="primary" variant="h4">
        {heading}
      </Typography>
    </Stack>
  );
};

export default SectionHeader;
